import { render, staticRenderFns } from "./UIDataTable.vue?vue&type=template&id=5f0a2ee2&scoped=true&"
import script from "./UIDataTable.vue?vue&type=script&lang=ts&"
export * from "./UIDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./UIDataTable.vue?vue&type=style&index=0&id=5f0a2ee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0a2ee2",
  null
  
)

export default component.exports